// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ag-0";
export var optionCard = "_ag-1";